import { ReduxStore } from "../../reducers/root_reducer";

const getLocationMetadata = (state: ReduxStore, props) => state.locationMetadata;

export default getLocationMetadata;
